import axios from "axios"
import * as XLSX from 'xlsx';

import AiAgentService from "@/services/cis-aiagent.service";

const cancelToken = axios.CancelToken;
var source = cancelToken.source();

const boldStyle = { font: { name: 'Consolas', bold: true } };
const floatNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0.0" };
const stringStyle = { font: { name: 'Consolas' } };
const indexNumStyle = { font: { name: 'Consolas' }, numFmt: "0" };
const intNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0" };
const intNumColorStyle = { font: { name: 'Consolas' }, numFmt: "[Blue]\\ \\▲#,##0;[Red]\\ \\▼#,##0;[Black]\\ \"-\"" };
const rateNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0.0%" };
const rateNumColorStyle = { font: { name: 'Consolas' }, numFmt: "[Blue]\\ \\▲#,##0%;[Red]\\ \\▼#,##0%;[Black]\\ \"-\"" };

export default class ExpXlSearchTag {
    constructor() {
        XLSX = require("xlsx-js-style");
    }

    newSheet4TagData(columns, data) {
      var tmp_sheet = [];

      // Header
      var header_list = ['No.', 'TAG'].concat(columns)
      var tmp_header = [];

      for (const col_nm of header_list) {
        tmp_header.push({ v: col_nm, t: "s", s: boldStyle });
      };

      tmp_sheet.push(tmp_header);

      // Data
      for (const idx in data) {
        var tmp_row = [];
        tmp_row.push({t: "n", v: Number(idx) + 1, s: stringStyle});         // No.
        tmp_row.push({t: "s", v: data[idx].tag, s: stringStyle});           // TAG
        tmp_row.push({t: "n", v: Number(data[idx].freq), s: intNumStyle});  // 검색량
        tmp_row.push({t: "s", v: data[idx].criteria, s: stringStyle});      // 구분

        tmp_sheet.push(tmp_row)
      }
      
      var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
      // ws['!cols'] = this.autoFit(tmp_sheet)

      return ws;
    }

    async xlExport(cat_id, st_dt, en_dt, dataset) {
        if (dataset.length == 0) 
            return ""

        const workbook = XLSX.utils.book_new()	// 엑셀 생성

        for (const sheet of dataset) {
            const sheet_nm = sheet.sheet_nm.replace(/[\/]/g, '').trim().substring(0, 31)

            XLSX.utils.book_append_sheet(workbook, 
                                        this.newSheet4TagData(sheet.cat, sheet.data), 
                                        sheet_nm)
        }

        // 엑셀 → ArrayBuffer 변환
        const buffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

        // Blob으로 변환 후 FormData에 담아 전송
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const file_nm = 'search_tag_' + cat_id + '_' + st_dt + '_' + en_dt + '.xlsx'

        const formData = new FormData();
        formData.append('file', blob, file_nm);
        formData.append('filename', file_nm); // 저장 경로 전달

        const response = await AiAgentService.callAiAgent_SaveExcel(formData, source)

        if(response && response.status == 200)
            return response.data.data.path
            // return response.data.path // for local test
        else
            return ""
    }
}